import { View } from 'modules/shift_management/lib/types'
import AllViewOptions from 'modules/shift_management/store/internal/collections/AllViewOptions'
import {
  CoverageOptions,
  EmployeeOptions,
  OtherOptions,
  ScheduleOptions,
} from 'modules/shift_management/store/internal/models/ViewOptions'

export type ViewOptionsState = {
  allViewOptions: AllViewOptions
}

export type ViewOptionsDispatch = (arg0: ViewOptionsAction) => void

export type ViewOptionsAction =
  | {
      type: 'TOGGLE_EMPLOYEE_OPTION'
      view: View
      option: keyof EmployeeOptions
    }
  | {
      type: 'TOGGLE_SCHEDULE_OPTION'
      view: View
      option: keyof ScheduleOptions
    }
  | {
      type: 'TOGGLE_COVERAGE_OPTION'
      view: View
      option: keyof CoverageOptions
    }
  | {
      type: 'TOGGLE_OTHER_OPTION'
      view: View
      option: keyof OtherOptions
    }
  | {
      type: 'RESET_ALL_OPTIONS'
      view: View
    }

export function initialViewOptionsState({
  allViewOptions,
}: {
  allViewOptions?: AllViewOptions
}): ViewOptionsState {
  return { allViewOptions: allViewOptions || new AllViewOptions([]) }
}

export default function reducer(
  state: ViewOptionsState,
  action: ViewOptionsAction
): ViewOptionsState {
  switch (action.type) {
    case 'TOGGLE_EMPLOYEE_OPTION':
      return {
        ...state,
        allViewOptions: state.allViewOptions.toggleEmployeeOption(action.view, action.option),
      }

    case 'TOGGLE_SCHEDULE_OPTION':
      return {
        ...state,
        allViewOptions: state.allViewOptions.toggleScheduleOption(action.view, action.option),
      }

    case 'TOGGLE_COVERAGE_OPTION':
      return {
        ...state,
        allViewOptions: state.allViewOptions.toggleCoverageOption(action.view, action.option),
      }

    case 'TOGGLE_OTHER_OPTION':
      return {
        ...state,
        allViewOptions: state.allViewOptions.toggleOtherOption(action.view, action.option),
      }

    case 'RESET_ALL_OPTIONS':
      return {
        ...state,
        allViewOptions: state.allViewOptions.resetAllOptions(action.view),
      }

    default:
      return state
  }
}
